import { Route, Routes } from 'react-router-dom'

import Overview from './screens/TaskListItems/screens/Overview'
import TeamOverview from './screens/TaskListItems/screens/TeamOverview'

const TasksRoutes = () => (
  <Routes>
    <Route path="/" element={<Overview />} />
    <Route path="/teamOverview" element={<TeamOverview />} />
  </Routes>
)

export default TasksRoutes
